import React from "react";
import {cn} from "../utils";

const ArrowRightCircleIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="21"
        viewBox="0 0 20 21"
        width="20"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m10 20.0625c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10zm1.0304-13.53033c-.2929-.29289-.7678-.29289-1.06068 0-.29289.29289-.29289.76777 0 1.06066l1.71968 1.71966h-5.38935c-.41421 0-.75.33578-.75.75001 0 .4142.33579.75.75.75h5.38935l-1.71968 1.7197c-.29289.2929-.29289.7677 0 1.0606.29288.2929.76778.2929 1.06068 0l3-3c.2929-.2929.2929-.76774 0-1.06063z"
              fill={color || "currentColor"} fillRule="evenodd"/>
    </svg>
)
;

export {ArrowRightCircleIcon};